import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { USER_ROLES } from './url-constants';

type UserRoleEndpointSpecification = ApiEndpointSpecification;
export const UserRoleEndpointSpecification: UserRoleEndpointSpecification = {
    url: USER_ROLES,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'UserRoleRequestParams',
    requestBodySchemaName: 'UserRoleRequestBody',
    okResponseSchemaName: 'UserRoleOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: false,
};

export const invokeUserRole = Helpers.makeApiRequestFn<
    Types.UserRoleRequestParams,
    Types.UserRoleRequestBody,
    Types.UserRoleOkResponse
>(UserRoleEndpointSpecification);
